import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCancelAmendment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tsdId: string) => {
      const result = await apiClient.tsd.cancelAmendment.mutation({ params: { tsdId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage amended!');
    },
    onError: (error) => {
      showErrorToast(error, `Error amending the temporary storage!`);
    },
  });
};
